// A failed load, told apart by cause: kast-common's ErrorState. An auth
// failure while signed out is the sign-in prompt, never "no workspaces"; while
// signed in it offers signing out and back in; anything else shows the error
// with a retry.
import { signUpUrl } from "@jkast90/kast-common/auth";
import { ErrorState, SignInScreen } from "@jkast90/kast-common/ui";
import { startSignIn } from "../../auth/session";
import { SIGN_IN_DETAIL } from "./signInText";

interface Props {
  error: unknown;
  isLoggedIn: boolean;
  onLogin?: () => void;
  onLogout?: () => void;
  onRetry?: () => void;
}

export default function ErrorMessage({
  error,
  isLoggedIn,
  onLogin,
  onLogout,
  onRetry,
}: Props) {
  if (!isLoggedIn) {
    return (
      <div data-testid="sign-in-prompt">
        <SignInScreen
          onSignIn={onLogin ?? startSignIn}
          signUpHref={signUpUrl()}
          detail={SIGN_IN_DETAIL}
        />
      </div>
    );
  }

  return (
    <ErrorState
      error={error ?? "Something went wrong."}
      signedIn
      onRetry={onRetry}
      onSignOut={onLogout}
    />
  );
}
